<template>
  <HowTo :sections="sections" :shortcutHeading="'FAQ Categories'" />
</template>

<script>
import HowTo from "@/components/Dashboard/HowTo/HowTo.vue";
export default {
  name: "FAQ",
  components: { HowTo },

  data() {
    return {
      sections: [
        {
          title: "My Account",
          questions: [
            {
              title:
                "How do I upload/change the branding on my Playbooks and Snap Sheets?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Open Sales Tools / Gameplan",
                    "2. Click on “My Settings” from the top menu bar",
                    "3. Click on the grey box with a green dashed border",
                    "4. Upload your company’s logo (all file formats accepted)",
                    "5. Click on the blue Save Changes button",
                  ],
                },
                {
                  type: "p",
                  text: "TIP: .pngs work best but company logo’s with a white background will work here. Logos will be placed on a white background so logos with white text and no borders might have pieces disappear.",
                },
              ],
            },
            {
              title: "How can I add a new sales rep to my Sales Tool account?",
              content: [
                {
                  type: "p",
                  text: "There are two ways to add a new rep to your Sales Tools / Gameplan account:",
                },
                {
                  type: "p",
                  text: "From My Settings:",
                },

                {
                  type: "list",
                  items: [
                    "1. Click on “My Settings” within Sales Tools.",
                    "2. Scroll down until you see the Sales Rep section and click the blue +Add User button",
                  ],
                },

                {
                  type: "p",
                  text: "From New Project:",
                },

                {
                  type: "list",
                  items: [
                    "1. Click on “Create a Playbook” or “Create a Snap Sheet”.",
                    "2. From Creation Mode look for the Sales Rep field on the left-hand sideof the screen. If you click the down arrow a list of existing reps will appear.",
                    "3. At the top of the rep list is an option to add a new rep.",
                  ],
                },
              ],
            },

            {
              title:
                "How can I edit contact info for a sales rep on my Sales Tools Account?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Click on “My Settings” within Sales Tools / Gameplan",
                    "2. Scroll down until you see the Sales Rep section and click on the blue pencil/edit button under actions",
                    "3. Edit/Replace any contact info you want changed",
                    "4. Click on blue “Save Changes”",
                  ],
                },
              ],
            },
            {
              title:
                "How can I delete a sales rep from my Sales Tools account?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Click on “My Settings” within Sales Tools / Gameplan",
                    "2. Scroll down until you see the Sales Rep section and click on the blue trash can/remove button under actions",
                    "3. You should get a confirmation request at the top of your screen. Click OK to confirm and delete the rep",
                  ],
                },
              ],
            },
            {
              title:
                "How do I view/edit past Playbooks and Snap Sheets that I’ve created?",
              content: [
                {
                  type: "p",
                  text: "There are two ways to view/edit past Playbooks and Snap Sheets:",
                },
                { type: "p", text: "From My Projects:" },

                {
                  type: "list",
                  items: [
                    "1. Click on “My Projects” within Sales Tools / Gameplan. Here you can view all past projects created.",
                    "2. Click on the three dots to the right of any project title",
                    "3. Click on View this Project and the Playbook/Snap Sheet will open in a new tab",
                    "4. This project will open in Dealer Mode with all edits and changes available",
                  ],
                },

                { type: "p", text: "From Project URL:" },

                {
                  type: "list",
                  items: [
                    "1. If you know the custom URL for a project you can always type that into a new tab at any time.",
                    "2. If you open a project directly using a URL in a new tab, by default this project will open in Coach Mode with limited edits and changes available.",
                    "3. To unlock all editing capabilities, scroll to the bottom of the page and click on Dealer Login.",
                    "4. Enter your Gameplan password (founders) and click confirm to switch the project to Dealer Mode where changes are enabled",
                  ],
                },
              ],
            },
            {
              title:
                "Where can I view the lockers (carts) that my customers submitted quote requests for?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Click on “Messages” within Sales Tools / Gameplan",
                    "2. Scroll and use the page arrows to browse your messages",
                    "3. Click on the blue eye/view quote button under actions and the specific quote selected will open in a new tab.",
                  ],
                },
              ],
            },
            {
              title: "How can I turn my customer’s Locker into an order?",
              content: [
                {
                  type: "p",
                  text: "There are two ways to turn a Locker into an order:",
                },
                {
                  type: "p",
                  text: "Order via Email:",
                },
                {
                  type: "list",
                  items: [
                    "1. Call your customer to finalize their selections, pricing, and orderdetails.",
                    "2. Forward their quote email and order details to our team at gameplan@foundersportgroup.com and we’ll get the order started for you.",
                  ],
                },
                {
                  type: "p",
                  text: "Open an Order My Gear Store:",
                },
                {
                  type: "list",
                  items: [
                    "1. Locate the project under My Projects in Sales Tools / Gameplan",
                    "2. Click on the three dots to the right of the project title",
                    "3. Click on “Send to OMG” and someone on OMG’s Team will build a store based on the product assorted included in the  customer’s quote.",
                    "4. Once your store closes you will still have to download the order report and place orders over foundersport.com/phone   against the orders received.",
                  ],
                },
              ],
            },
            {
              title:
                "Where can I edit the email where my customers’ Lockers (carts) get sent?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Click on “My Settings” within Sales Tools / Gameplan",
                    "2. Scroll down until you see Embedded Options and “Email for quotes”",
                    "3. Edit/Replace the email address listed",
                    "4. Scroll up to the top of the page and click on blue “Save Changes”",
                  ],
                },
              ],
            },
          ],
        },

        // Playboooks
        {
          title: "Playbooks",
          questions: [
            {
              title: "How can I create a new Playbook?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Scroll up to the menu bar at the top of foundersport.com",
                    "2. Click on Sales Tools/Gameplan",
                    "3. From the dropdown menu click on Create a Playbook",
                    "4. Fill in/Upload information  relating to your customer in the Creation Mode panel",
                    "5. When finished, click the “Mark as Finished” button in the top right corner",
                  ],
                },
              ],
            },
            {
              title:
                "What information do I need in order to create a Playbook?",
              content: [
                {
                  type: "p",
                  text: "In order to create a Playbook you need a few basic pieces of information:",
                },
                {
                  type: "list",
                  items: [
                    "1. The name and/or logo of your customer",
                    "2. The  colors your customer wears or has in their logo",
                    "3. The sport your customer plays (We have a Spiritwear option included in case your customer isn’t a sports team).",
                  ],
                },
              ],
            },
            {
              title:
                "What if my customer doesn’t appear in the school database?",
              content: [
                {
                  type: "p",
                  text: "Our database has over 100,000 schools and is constantly beingupdated. If we don’t have the school you’re looking for, simply click the “Start From Scratch” button to enter their information manually",
                },
              ],
            },
            {
              title:
                "What I don’t see the sport my customer plays in the list of options?",
              content: [
                {
                  type: "p",
                  text: "We’re continuously updating Sales Tools/Gameplan to offer a product that matches our  dealers’ needs.  If  you  don’t see  a template  for the type of customer you’re working with, send us an email at gameplan@foundersport.com and we can add your request to the queue for future updates.",
                },
              ],
            },
            {
              title:
                "How can I add new contact info if my name isn’t on the dropdown list of sales reps?",
              content: [
                {
                  type: "p",
                  text: "If you don’t see your name in the dropdown menu then it will only take a moment to get you added and ready to create Playbooks.",
                },
                {
                  type: "list",
                  items: [
                    "1. Click on the down arrow to expand the list of existing reps ",
                    "2. At the top of the list will appear an option to add a new rep",
                    "3. Click on “Add New Rep” and enter your preferred contact info (name, email and phone number) to follow up with you directly.",
                  ],
                },
              ],
            },
            {
              title:
                "What if I have a graphic for my customer but it has a white/colored background?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Start a new Playbook or open Creator Mode for an existing Playbook",
                    "2. Click on “Add Graphic” to upload the image",
                    "3. Once the image loads click continue",
                    "4. Click on the “Remove Background” button with a wand icon",
                    "5. Move your mouse over the graphic and click on the background you want to remove",
                    "6. Click Save Graphic",
                  ],
                },
              ],
            },
            {
              title:
                "What if I have a graphic for my customer but I want to crop part of it?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Start a new Playbook or open Creator Mode for an existing Playbook",
                    "2. Click on “Add Graphic” to upload the image",
                    "3. Once the image loads click the Crop button",
                    "4. Adjust the image as needed using the editor. Click and drag on corners to resize the crop frame.",
                    "5. When finished click Save Changes",
                    "6. Click Continue",
                    "7. Click Save Graphic",
                  ],
                },
              ],
            },
            {
              title:
                "What if I’m not sure exactly what sports my customer might be interested in?",
              content: [
                {
                  type: "p",
                  text: "We have a wide range of individual sport templates to meet customer’s specific needs but our All Sports template is a great tool to start conversations with new leads",
                },
              ],
            },
            {
              title: "What if I’m working with an all-female organization?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Start a new Playbook or open Creator Mode for an existing Playbook",
                    "2. Scroll down to the bottom of the customization panel",
                    "3. Under “Featured Gender” click on Women or Girls to adjust your Playbook. Where available, this will replace mens/unisex product images with female product images and make female product details the lead styles at the top of each product section.",
                  ],
                },
              ],
            },
            {
              title: "How do I share a finished Playbook with a customer?",
              content: [
                {
                  type: "p",
                  text: "Once you’ve marked a Playbook as finished there are two ways you can present this to a customer.",
                },
                {
                  type: "p",
                  text: "Share via URL:",
                },
                {
                  type: "list",
                  items: [
                    "1. Click copy URL in the top right-hand corner (must be in Dealer Mode to see)",
                    "2. Paste and send this custom URL to a customer in an email",
                  ],
                },
                {
                  type: "p",
                  text: "Export To PDF:",
                },
                {
                  type: "list",
                  items: [
                    "1. Click Export To PDF in the top right-hand corner (must be in Dealer Mode to see)",
                    "2. Sales Tools / Gameplan will generate and download a PDF to your computer",
                    "3. Locate and open the PDF file",
                    "4. Print this document for in-person meetings",
                  ],
                },
              ],
            },
          ],
        },
        // Snapsheets
        {
          title: "Snapsheets",
          questions: [
            {
              title: "How can I create a new Snap Sheet?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Scroll up to the menu bar at the top of foundersport.com",
                    "2. Click on Sales Tools/Gameplan",
                    "3. From the dropdown menu click on Create a Snap Sheet",
                    "4. Fill in/Upload information  relating to your customer in the Creation Mode panel",
                    "5. When finished, click the “Mark as Finished” button in the top right corner",
                  ],
                },
              ],
            },
            {
              title:
                "What information do I need in order to create a Snap Sheet?",
              content: [
                {
                  type: "p",
                  text: "In order to create a Snap Sheet you need a few basic pieces of information:",
                },
                {
                  type: "list",
                  items: [
                    "1. At least one logo for your customer",
                    "2. The colors your customer wears or has in their logo",
                    "3. The product categories your customer is interested in",
                  ],
                },
              ],
            },
            {
              title:
                "What I don’t see the product category my customer needs in the list of options?",
              content: [
                {
                  type: "p",
                  text: "We’re continuously updating Sales Tools/Gameplan to offer a product that matches our  dealers’ needs. If you don’t see a template for the type of customer you’re working with, send us an email at gameplan@foundersport.com and we can add your request to the queue for future updates.",
                },
              ],
            },
            {
              title:
                "How can I add new contact info if my name isn’t on the dropdown list of sales reps?",
              content: [
                {
                  type: "p",
                  text: "If you don’t see your name in the dropdown menu then it will only take a moment to get you added and ready to create Snap Sheet.",
                },
                {
                  type: "list",
                  items: [
                    "1. Click on the down arrow to expand the list of existing reps",
                    "2. At the top of the list will appear an option to add a new rep",
                    "3. Click on “Add New Rep” and enter your preferred contact info (name, email and phone number) to follow up with you directly",
                  ],
                },
              ],
            },
            {
              title:
                "What if I have a graphic for my customer but it has a white/colored background?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Start a new Snap Sheet or open Creator Mode for an existing Snap Sheet",
                    "2. Click on “Add Graphic” to upload the image",
                    "3. Once the image loads click continue",
                    "4. Click on the “Remove Background” button with a wand icon",
                    "5. Move your mouse over the graphic and click on the background you want to remove",
                  ],
                },
              ],
            },
            {
              title:
                "What if I have a graphic for my customer but I want to crop part of it?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Start a new Snap Sheet or open Creator Mode for an existing Snap Sheet",
                    "2. Click on “Add Graphic” to upload the image",
                    "3. Once the image loads click the Crop button",
                    "4. Adjust the image as needed using the editor. Click and drag on corners to resize the crop frame.",
                    "5. When finished click Save Changes",
                    "6. Click Continue",
                  ],
                },
              ],
            },
            {
              title:
                "What if I’m not sure exactly what products my customer might be interested in?",
              content: [
                {
                  type: "p",
                  text: "We have a wide range of pre-made product categories (T-shirts, Polos, Hoodies, ¼ Zips, etc.) for you to choose from that can be a great tool to start conversations with new leads.",
                },
              ],
            },
            {
              title: "What if I’m working with an all-female organization?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Start a new Snap Sheet or open Creator Mode for an existing Snap Sheet",
                    "2. Scroll down to the bottom of the customization panel",
                    "3. Under “Featured Gender” click on Women or Girls to adjust your ,Snap Sheet. Where available, this will replace mens/unisex product images with female product images and make female product details the lead styles at the top of each product section.",
                  ],
                },
              ],
            },

            {
              title: "How can I add/remove a product?",
              content: [
                {
                  type: "p",
                  text: "There are two ways to add/remove products to Snap Sheets",
                },
                {
                  type: "p",
                  text: "Add/Remove by Category:",
                },

                {
                  type: "list",
                  items: [
                    "1. Start a new Snap Sheet or open Creator Mode for an existing Snap Sheet",
                    "2. Find “Choose Categories” in the customization panel",
                    "3. Click on a category once to add all the accompanying pre-selected products. The icon will turn green when included in your Snap Sheet.",
                    "4. Click on a category a second time to remove all the accompanying pre-selected products. The icon will look white when excluded from your Snap Sheet.",
                  ],
                },

                {
                  type: "p",
                  text: "Add/Remove Manually:",
                },
                {
                  type: "list",
                  items: [
                    "1. Start a new Snap Sheet or open Creator Mode for an existing Snap Sheet",
                    "2. To add products, click “Select Products Manually” from the customization panel or go to the last page of your Snap Sheet and click the “Add Products” button.",
                    "3. Type a product’s style number or name. Once found, click on the name to add.",
                    "4. Click on the green “Add Product” button to confirm the addition.",
                    "5. To remove products, hover over the item in question and click the trash can icon to delete products.",
                  ],
                },
              ],
            },
            {
              title: "How do you change the decoration on products",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Find “My Graphics” in the customization panel",
                    "2. Click on the “Add Graphic” button and upload a new file",
                    "3. Click “Continue”",
                    "4. Click “Save Graphic” and your new upload should now appear in the “My Graphics” section under “Other Graphics”",
                    "5. Hover over the graphic and click “Make Default Graphic” to place the new graphic on all products.",
                  ],
                },
              ],
            },
            {
              title: "How do I change the color of products?",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Find “Select Clients Colors” in the customization panel",
                    "2. Click on the desired new color",
                  ],
                },
              ],
            },
            {
              title: "How can I move products around in my Snap Sheet",
              content: [
                {
                  type: "list",
                  items: [
                    "1. Hover over a product to pull up the creator icons to the left of the page",
                    "2. Use the up arrow to move a product up one space in the Snap Sheet",
                    "3. Use the down arrow to move a product down one space in the Snap Sheet",
                  ],
                },
              ],
            },
            {
              title: "How do I share a finished Snap Sheet with a customer?",
              content: [
                {
                  type: "p",
                  text: "Once you’ve marked a Snap Sheet as finished there are two ways you can present this to a customer.",
                },
                {
                  type: "p",
                  text: "Share via URL:",
                },
                {
                  type: "list",
                  items: [
                    "1. Click copy URL in the top right-hand corner (must be in Dealer Mode to see)",
                    "2. Paste and send this custom URL to a customer in an email",
                  ],
                },
                {
                  type: "p",
                  text: "Export To PDF:",
                },
                {
                  type: "list",
                  items: [
                    "1. Click Export To PDF in the top right-hand corner (must be in Dealer Mode to see)",
                    "2. Sales Tools / Gameplan will generate and download a PDF to your computer",
                    "3. Locate and open the PDF file",
                    "4. Print this document for in-person meetings",
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
  },

  mounted() {
    this.$store.commit("setActivePage", "FAQ");
  },
};
</script>
